import React from 'react';
import SlideShow from './slideshow';

const {
    hoc: {withNoProps},
    hooks: {useSelector, useFeaturedMedia},
    css: {prefixCSS},
    components: {generic: {Image, Video}}
} = polyphony;

const styles = {
    homeHeader: prefixCSS({
        width: '100%',
        height: '100vh',
        display: "flex",
        alignItems: 'center',
        justifyContent: 'center'
    }),
    header: {
        background: 'black',
        height: 600,
        width: '100%',
        position: 'relative'
    },
    titleAbsWrapper: prefixCSS({
        top: 0,
        position: 'absolute',
        width: '100%',
        height: '100%',
        color: 'white',
        fontSize: 50,
        display: 'flex',
        alignItems: 'center'
    }),
    media: prefixCSS({
        objectFit: 'cover',
        width: "100%",
        height: "100%"
    })
};

const TitleArea = withNoProps(() => {
    const isHome = useSelector(s => s.is.front_page);
    const isArchive = useSelector(s => !s.is.singular);
    const title = useSelector(s => s.webpage_title);
    let matching = useFeaturedMedia();

    if (isHome) {
        return <header className="title-area-home" style={styles.homeHeader}>
            <SlideShow name="slideshow" />
        </header>;
    }

    const isImage = matching && matching.type === 'image';
    const isVideo = matching && matching.type === 'video';

    return (
        <header className='title-area' style={styles.header}>
            {isImage && <Image key="image" media={matching} style={styles.media} />}
            {isVideo && <Video key="video" src={matching.url} mimeType={matching.mimeType} style={styles.media} autoplay />}
            {!isHome && isArchive && <div role="none" style={styles.titleAbsWrapper}>
                <div role="none" style={{width: '100%', textAlign: 'center'}}>
                    {title}
                </div>
            </div>}
        </header>
    );
});

export default TitleArea;

